/**
 * Get human-readable label for migration status
 */
export const getMigrationStatusLabel = (status) => {
    const STATUS_LABELS = {
        draft: 'Draft',
        in_progress: 'In Progress',
        canceling: 'Canceling',
        completed: 'Completed',
        canceled: 'Canceled',
    };

    return STATUS_LABELS[status] || status;
};
